import { render } from "./ChangePassword.vue?vue&type=template&id=4bd85ebe&ts=true"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"

import "./ChangePassword.vue?vue&type=style&index=0&id=4bd85ebe&lang=css"
import "./ChangePassword.vue?vue&type=style&index=1&id=4bd85ebe&lang=scss"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__